import s from "./help-center-articles-search30.js";
import r from "./help-center-articles-search31.js";
import i from "./help-center-articles-search32.js";
import t from "./help-center-articles-search33.js";
import v from "./help-center-articles-search34.js";
import e from "./help-center-articles-search35.js";
import a from "./help-center-articles-search36.js";
import n from "./help-center-articles-search37.js";
import m from "./help-center-articles-search38.js";
import p from "./help-center-articles-search39.js";
import _ from "./help-center-articles-search40.js";
import o from "./help-center-articles-search41.js";
import f from "./help-center-articles-search42.js";
import C from "./help-center-articles-search43.js";
const S = {
  da_dk: {
    vistaprint: s
  },
  en_us: {
    vistaprint: r
  },
  en_ca: {
    vistaprint: r
  },
  de_de: {
    vistaprint: i
  },
  de_ch: {
    vistaprint: i
  },
  de_at: {
    vistaprint: i
  },
  en_au: {
    vistaprint: t
  },
  en_gb: {
    vistaprint: t
  },
  en_ie: {
    vistaprint: t
  },
  en_in: {
    vistaprint: t
  },
  en_nz: {
    vistaprint: t
  },
  en_sg: {
    vistaprint: t
  },
  es_es: {
    vistaprint: v
  },
  es_us: {
    vistaprint: e
  },
  fi_fi: {
    vistaprint: a
  },
  fr_be: {
    vistaprint: n
  },
  fr_ca: {
    vistaprint: m
  },
  fr_ch: {
    vistaprint: n
  },
  fr_fr: {
    vistaprint: n
  },
  it_ch: {
    vistaprint: p
  },
  it_it: {
    vistaprint: p
  },
  nb_no: {
    vistaprint: _
  },
  nl_be: {
    vistaprint: o
  },
  nl_nl: {
    vistaprint: o
  },
  pt_pt: {
    vistaprint: f
  },
  sv_se: {
    vistaprint: C
  }
};
export {
  S as default
};
//# sourceMappingURL=help-center-articles-search26.js.map
